import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  jsonKeyMapping,
  NO_GROUP,
  templateActionEnum,
} from "../../../Config/Constants";
import TemplateDataContext from "../../../Contexts/TemplateData.context";
import FormDataContext from "../../../Contexts/FormData.context";
import { TemplateObject } from "../../../Models/TemplateObject";
import {
  isStepCompleted,
  hasIncompleteFields,
} from "../../../Util/StepCompletionHelper";

type Props = {
  step: TemplateObject;
  uri: string;
  isVisited: boolean;
  isActive: boolean;
  onAttemptNavigate?: (step: TemplateObject, defaultNavigate: () => boolean) => boolean | void; // returns true if intercepted
  shouldInterceptNavigation?: boolean;
};

const NavBarItem = ({ step, uri, isActive, isVisited, onAttemptNavigate, shouldInterceptNavigation }: Props) => {
  const { dispatch } = useContext(TemplateDataContext);
  const { state: formState } = useContext(FormDataContext);
  const { formData } = formState;

  // Determine step completion status
  const stepCompleted = isStepCompleted(step, formData);
  const stepIncomplete = hasIncompleteFields(step, formData);

  /* side navbar handler */
  const handleClose = () => {
    dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
    dispatch({ type: templateActionEnum.SET_ACTIVE_GROUP, payload: NO_GROUP });
  };

  const rawLabel: string = (step[jsonKeyMapping.NAV_TITLE] || step[jsonKeyMapping.SLUG] || '').toString();
  const slugBase = useMemo(() => rawLabel
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-'), [rawLabel]);
  const idAttr = `nav-item-${slugBase}`;

  const navigateHref = `${uri}/${step[jsonKeyMapping.SLUGIFY]}`;
  const defaultNavigate = () => {
    handleClose();
    return false; // not intercepted
  };
  const handleClick = (e: React.MouseEvent) => {
    if (shouldInterceptNavigation && onAttemptNavigate) {
      const intercepted = onAttemptNavigate(step, defaultNavigate);
      if (intercepted) {
        e.preventDefault();
        return;
      }
      // if not intercepted, allow link navigation (do not preventDefault)
      handleClose();
      return;
    }
    // normal path
    handleClose();
  };

  return (
    <li
      className={`list-group-item body-font3 ${isActive && "active fw-700"} ${
        stepCompleted && !isActive && "completed"
      } `}
    >
      <Link to={navigateHref} onClick={handleClick}>
        <div className="nav-item-text" id={idAttr} data-nav-slug={slugBase}>
          {rawLabel}
        </div>
        <div className="nav-spacer"></div>
        <div className="nav-icon">
          {stepCompleted && (
            <img
              src={`${process.env.PUBLIC_URL}/static/images/check-step.svg`}
              alt="Completed"
              className="icon-img"
            />
          )}
          {stepIncomplete && !stepCompleted && (
            <img
              src={`${process.env.PUBLIC_URL}/static/images/text.svg`}
              alt="Incomplete"
              className="icon-img"
            />
          )}
        </div>
      </Link>
    </li>
  );
};

export default NavBarItem;
